import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const ChangeTariffModule = {
  namespaced: true,
  state: {
    bookedTariff: {},
    bookableTariffs: {},
    view: 'input',
    selectedTariffName: null,
    processId: null,
    contractUrl: null
  },
  actions: {
    async changeTariff ({ commit, state }, { tariffId, tariffName }) {
      state.selectedTariffName = tariffName
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation changeTariff($bookTariff: BookTariffInput!){
          changeTariff (bookTariff: $bookTariff){
            success,
            processId,
            contractUrl,
            notification{
              delay, text, title
            }
          }
        }`,
        variables: {
          bookTariff: {
            tariffId: tariffId
          }
        }
      }).then((response) => {
        commit('processId', response.data.changeTariff.processId)
        commit('storeContractUrl', response.data.changeTariff.contractUrl)
        return response.data.changeTariff
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmChangeTariff ({ commit, state, getters, rootGetters }, { nextStep = 'success' }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation changeTariff ($confirmTariffChange: ConfirmTariffChangeInput!) {
          confirmTariffChange (confirmTariffChange: $confirmTariffChange){
            success
          }
        }`,
        variables: {
          confirmTariffChange: {
            processId: state.processId
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'changeTariff', { root: true })
        if (response.data.confirmTariffChange.success === true) {
          state.view = nextStep
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }

  },
  mutations: {
    changeStep (state, nextStep) {
      state.view = nextStep
    },
    processId (state, id) {
      state.processId = id
    },
    storeContractUrl: (state, contractUrl) => {
      state.contractUrl = contractUrl
    }
  },
  getters: {
    currentStep (state) {
      return state.view
    },
    selectedTariffName (state) {
      return state.selectedTariffName
    },
    getProcessId: state => {
      return state.processId
    },
    contractUrl: (state) => {
      return state.contractUrl
    }
  }
}

export {
  ChangeTariffModule
}
